export var ProductTicketStatus;
(function (ProductTicketStatus) {
    ProductTicketStatus["Pending"] = "pending";
    // the transaction is pending validation.
    ProductTicketStatus["Active"] = "active";
    ProductTicketStatus["Canceled"] = "canceled";
    ProductTicketStatus["CheckedIn"] = "checked-in";
})(ProductTicketStatus || (ProductTicketStatus = {}));
